import {
  decorateFetch,
  FetchFn,
  CookieUtil,
  FetchDecorator,
  FetchOptions,
  Location,
  LocalStorage
} from '../fetch'

/**
 * The ApiConnector wraps a FetchFn and handles data flow between the Contrast UI
 * and the data sources (REST API endpoints).
 *
 * This implementation of the Connector interface handles the following:
 * - Wraps the fetch API
 * - Understand Contrast API headers, JSON usage, and special error responses
 * - Throws a custom error
 */
export class ApiConnector {
  private readonly fetchJson: FetchDecorator

  constructor(
    fetch: FetchFn,
    cookies: CookieUtil,
    location: Location | null,
    localStorage: LocalStorage | null
  ) {
    this.fetchJson = decorateFetch(fetch, cookies, location, localStorage)
  }

  public get = (path: string) => this.fetch(path, { method: 'GET' })

  public executeDelete = (path: string, body?: any) =>
    this.fetch(path, { method: 'DELETE', body })

  public put = (path: string, body?: any) =>
    this.fetch(path, { method: 'PUT', body })

  public post = (path: string, body?: any) =>
    this.fetch(path, { method: 'POST', body })

  private fetch = async (path: string, options: FetchOptions) => {
    // This prefixing code should not exist, the small redunancy of
    // adding your absolute path directly in the api call is worth
    // the trade off of not having this logic. As we move to v4 api
    // this should be removed entirely.
    const contrastBasePrefix = '/Contrast/api'
    const prefix = path.startsWith('/api/ui/')
      ? '' // no prefix for the new api
      : /^\/?serverless/.exec(path) || path.startsWith('public')
      ? contrastBasePrefix // route serverless requests to serverless proxy or public routes
      : `${contrastBasePrefix}/ng` // default prefix

    const res = await this.fetchJson(
      `${prefix}${path.startsWith('/') ? path : `/${path}`}`,
      options
    )

    return res.json()
  }
}
